import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { config } from 'config';
import { getCurrentUserJWTToken } from 'context/AuthContext';

const httpLink = createHttpLink({
  uri: config.nviewAPIUrl,
});

const authLink = setContext((_, { headers }) => {
  const token = getCurrentUserJWTToken();

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;
